// Implements: F-UIX-018, F-CNV-003
/**
 * The usage status the conversation view reads (CNV.2, UIX.1).
 *
 * One `GET`, sent at most once per read: `retry: false`. The status only decides
 * whether a discreet notice shows, so a failed read shows nothing rather than
 * asking again, and every read is exactly one request towards the per-minute
 * limit the T1 measurement sized (S5b: one read on opening, one per settled turn).
 */

import { httpRequest } from "../../../shared/api/httpClient";
import type { UsageStatusView } from "../../../types/api";

/** `GET /usage/status?mockup_id=`, with the id encoded as one query value. */
export function usageStatusPath(mockupId: string): string {
  return `/api/usage/status?mockup_id=${encodeURIComponent(mockupId)}`;
}

/** The person's usage status for one mockup, or `null` when the server said nothing readable. */
export async function fetchUsageStatus(
  mockupId: string,
  signal?: AbortSignal,
): Promise<UsageStatusView | null> {
  const body = await httpRequest<UsageStatusView>(usageStatusPath(mockupId), { signal, retry: false });
  return body ?? null;
}
